export enum PayloadType {
    INVITE_FRIEND = 'inviteFriend',

    HELP_FRIEND = 'helpFriend',

    SEND_CURRENCY = 'SetCurrency',
    SEND_FRIEND_GIFT = 'ShareGift',
    REQUEST_CURRENCY = 'GetCurrency',

    SHARE_BEAT_HIGHSCORE_LEVEL = 'ShareBeatHighscoreLevel',
    SHARE_3_STAR_REWARD = 'Share3StarReward',
    SHARE_FIELD_UNLOCKED = 'ShareFieldUnlocked',
    SHARE_CROP_UNLOCKED = 'ShareCropUnlocked',
    SHARE_PET_UNLOCKED = 'sharePetUnlocked',
    SHARE_PET_JACKPOT = 'ShareMyPetMiniGameJackpot',
    SHARE_LUCKY_WHEEL_REWARD = 'shareLuckyWheelReward',
    SHARE_PREMIUM_SHEEL_REWARD = 'sharePremiumWheelReward',
    SHARE_HARD_LEVEL = 'shareHardLevel',
    SHARE_FARM = 'shareFarm',

    BOT_MESSAGE = 'botMessage',
}
